import { IGoal } from "motw_core/Entity/IGoal";
import { logRepository } from "motw_core/Repositories/LogRepository";
import { IGoalsContainerState } from "source/app/presentation/MainPanel/Goals/IGoalsState";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import {
    OnErrorAddLogEntry,
    OnFinishAddLogEntry,
} from "source/app/services/Log/AddEntry";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import * as toastr from "toastr";

export async function HandleLoggingMatchingGoalAsync(matchingGoal?: IGoal) {
    if (!matchingGoal) {
        return;
    }

    const goalsContainer = State.ReadClass<IGoalsContainerState>(
        ESharedComponent.GoalsContainer
    );

    const goalStreakInfo = goalsContainer.state.GoalStreakInfo.find(
        (gsi) => gsi.result_goalid === matchingGoal.id
    );

    const hasBeenBookedAlready =
        goalStreakInfo!.badStreakLength === 0 && matchingGoal.isdaily;

    if (hasBeenBookedAlready) {
        return;
    }

    await logRepository.AddOneTimeLogEntryAsync(
        matchingGoal.verb,
        matchingGoal.name,
        ClientDataProvider,
        OnErrorAddLogEntry,
        OnFinishAddLogEntry
    );

    toastr.info(`Goal "${matchingGoal.name}" has been logged`, ``, {
        timeOut: 1000,
    });
}
